import { AuthLanguageSwitcher } from '@features/auth/components/AuthLanguageSwitcher'
import { CircleHelp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { MobileNav } from './MobileNav'
import { isUserRole, NavItem, NavUser } from './navConfig'
import { ProfileMenu } from './ProfileMenu'

interface AppTopbarProps {
  title: string
  user?: NavUser
  items: NavItem[]
}

export function AppTopbar({ title, user, items }: AppTopbarProps) {
  const { t } = useTranslation('userDashboard')

  return (
    <header className="app-chrome sticky top-0 z-30 flex h-20 items-center gap-3 border-b border-ink/[0.06] bg-white/85 px-4 backdrop-blur lg:px-8">
      <MobileNav items={items} />
      <h1 className="truncate font-display text-xl font-bold text-ink lg:text-2xl">
        {title}
      </h1>
      <div className="ml-auto flex items-center gap-2">
        {isUserRole(user?.role) && (
          <Link
            to="/user/welcome"
            aria-label={t('help')}
            title={t('help')}
            className="flex h-10 w-10 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-ink/[0.05] hover:text-ink"
          >
            <CircleHelp className="h-5 w-5" />
          </Link>
        )}
        <div className="hidden sm:block">
          <AuthLanguageSwitcher />
        </div>
        <ProfileMenu user={user} />
      </div>
    </header>
  )
}
